<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import Dialog from 'primevue/dialog';
import { useGradeStore } from '@/stores/useGradeStore.js';


export default {
  name: "index-questions",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      questions: [],
      lesson: null,
      lessons: [],
      unit: null,
      units: [],
      branch: null,
      branches: [],
      visible: false,
      // The image shown by the single, page-level preview Dialog. Set on click.
      selectedImage: null
    };
  },
  components: {
    Breadcrumb,
    Dropdown,
    Dialog
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    basePath() {
      return this.isCourseScope ? `/courses/${this.courseId}/question-bank` : `/${this.gradeSlug}/questions`;
    },
    // Legacy routes use a singular "question/add" segment for add/edit while the
    // list route is plural "questions" (pre-existing inconsistency) — course
    // routes use "question-bank" consistently everywhere.
    addPath() {
      return this.isCourseScope ? `${this.basePath}/add` : `/${this.gradeSlug}/question/add`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [...base, { name: "بنك الأسئلة", path: this.basePath }];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: "السؤال", path: this.basePath },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() { return this.resolvedGrade?.id ?? null; },
  },
  methods: {
    // Open the single preview dialog with the clicked image. Because there is only
    // one Dialog instance, this can never stack multiple dialogs/overlays.
    openImage(src) {
      this.selectedImage = src;
      this.visible = true;
    },

    fetchQuestions() {
      const params = this.isCourseScope ? { course_id: this.courseId } : { academic_year_id: this.gradeId };
      // Server-side filtering by the DEEPEST selected node. The backend's
      // lesson_id filter already expands to all descendant lessons
      // (getDescendantLessonIds), so a branch or unit id filters correctly too.
      const filterId = this.lesson?.id || this.unit?.id || this.branch?.id || null;
      if (filterId) {
        params.lesson_id = filterId;
      }

      axios
          .get('/questions', { params })
          .then((response) => {
            this.questions = response.data.data;
            // this.paggination = response.data.data.meta.total;
          })
          .catch((error) => {
            this.questions = [];
          });
    },

    /**
     * Reflect the current branch/unit/lesson selection into the URL query so the
     * filters survive navigation to Add/Edit, browser refresh, and back/forward.
     * `replace` (not push) keeps every dropdown tweak out of the history stack.
     */
    syncFiltersToUrl() {
      const query = { ...this.$route.query };
      delete query.branch_id; delete query.unit_id; delete query.lesson_id;
      if (this.branch?.id) query.branch_id = this.branch.id;
      if (this.unit?.id) query.unit_id = this.unit.id;
      if (this.lesson?.id) query.lesson_id = this.lesson.id;
      this.$router.replace({ query }).catch(() => {});
    },

    onBranchChange() {
      // Dependent selects reset when the parent changes.
      this.unit = null; this.units = [];
      this.lesson = null; this.lessons = [];
      if (this.branch?.id) this.fetchUnits();
      this.syncFiltersToUrl();
      this.fetchQuestions();
    },
    onUnitChange() {
      this.lesson = null; this.lessons = [];
      if (this.unit?.id) this.fetchLessons();
      this.syncFiltersToUrl();
      this.fetchQuestions();
    },
    onLessonChange() {
      this.syncFiltersToUrl();
      this.fetchQuestions();
    },

    /**
     * Restore branch → unit → lesson selections from the URL query on load,
     * loading each dependent option list in turn so all three selects show their
     * saved value, then fetch the filtered questions.
     */
    async restoreFiltersFromQuery() {
      const q = this.$route.query;
      const branchId = q.branch_id ? Number(q.branch_id) : null;
      const unitId = q.unit_id ? Number(q.unit_id) : null;
      const lessonId = q.lesson_id ? Number(q.lesson_id) : null;

      await this.fetchBranch();
      if (branchId) {
        this.branch = this.branches.find(b => b.id === branchId) || null;
        if (this.branch) {
          await this.fetchUnits();
          if (unitId) {
            this.unit = this.units.find(u => u.id === unitId) || null;
            if (this.unit) {
              await this.fetchLessons();
              if (lessonId) {
                this.lesson = this.lessons.find(l => l.id === lessonId) || null;
              }
            }
          }
        }
      }
      this.fetchQuestions();
    },

    deleteQuestion(question_id) {
      Swal.fire({
        title: "هل تريد الحذف ؟",
        text: "سيتم نقل العنصر إلى سلة المحذوفات ويمكن استرجاعه لاحقاً.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "رجوع",
        confirmButtonText: "احذف",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
              .delete(`questions/${question_id}`)
              .then(({ data }) => {
                if (data.status == true) {
                  Swal.fire("تم الحذف بنجاح", "", "success");
                  this.questions = this.questions.filter(r => r.id !== question_id);
                } else {
                  Swal.fire("", data.message, "error");
                }
              });
        }
      });
    },

    fetchBranch() {
      const params = this.isCourseScope
          ? { type: 1, course_id: this.courseId }
          : { type: 1, academic_year_id: this.gradeId };
      return axios
          .get('/lessons', { params })
          .then((response) => { this.branches = response.data.data; })
          .catch(() => {});
    },
    fetchUnits() {
      const branchId = this.branch?.id;
      const params = this.isCourseScope
          ? { type: 2, course_id: this.courseId, parent_id: branchId }
          : { type: 2, academic_year_id: this.gradeId, parent_id: branchId };
      return axios
          .get('/lessons', { params })
          .then((response) => { this.units = response.data.data; })
          .catch(() => {});
    },
    fetchLessons() {
      const unitId = this.unit?.id;
      const params = this.isCourseScope
          ? { type: 3, course_id: this.courseId, parent_id: unitId }
          : { type: 3, academic_year_id: this.gradeId, parent_id: unitId };
      return axios
          .get('/lessons', { params })
          .then((response) => { this.lessons = response.data.data; })
          .catch(() => {});
    },

    customLabelBranch(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelUnit(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelLesson(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    // Restore branch/unit/lesson from the URL query (survives return from
    // Add/Edit, refresh, back/forward) and fetch the filtered questions.
    this.restoreFiltersFromQuery();
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">
    <div class="filter my-3">
      <div class="filter-head">
        <div class="row d-flex align-items-center gap-4 w-75">
          <h4 class="mb-0 col-lg-2 col-12">السؤال</h4>
          <div class="row d-flex gap-lg-0 gap-2 col-lg-10 col-12 mb-lg-0 mb-2">
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="branch" :options="branches" showClear :optionLabel="customLabelBranch" placeholder="اختر الفرع" class="w-full md:w-14rem" @update:model-value="onBranchChange" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="unit" :options="units" showClear :optionLabel="customLabelUnit" placeholder="اختر الوحده" class="w-full md:w-14rem" @update:model-value="onUnitChange" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="lesson" :options="lessons" showClear :optionLabel="customLabelLesson" placeholder="اختر الدرس" class="w-full md:w-14rem" @update:model-value="onLessonChange" />
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <router-link :to="{ path: addPath, query: $route.query }" class="btn PrimaryButton">إضافة سؤال</router-link>
        </div>
      </div>
    </div>
    <div class="row reservation-table">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">الصورة</th>
              <th scope="col">العنوان</th>
              <th scope="col">نوع السؤال</th>
              <th scope="col">درجة السؤال</th>
              <th scope="col">صعوبة السؤال</th>
              <th scope="col">الدرس</th>
              <th scope="col">التحكم</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(question, index) in questions"
                :key="question.id"
            >
              <td data-label="ID">{{ index + 1 }}</td>
              <td data-label="الصورة">
                <img @click="openImage(question.image)" v-if="question.image" :src="question.image" alt="question Image" style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px; cursor: pointer" />
                <span v-else>--- </span>
              </td>
              <td data-label="الاسم">{{ question.title }}</td>
              <td data-label=">نوع السؤال">{{ question.type }}</td>
              <td data-label=">نوع السؤال">{{ question.degree }}</td>
              <td data-label="صعوبة السؤال">
                <span v-if="question.difficulty_level === 'easy'">سهل</span>
                <span v-else-if="question.difficulty_level === 'medium'">متوسط</span>
                <span v-else-if="question.difficulty_level === 'hard'">صعب</span>
              </td>
              <td data-label="الدرس">{{ question.lesson ? question.lesson?.title : '---' }}</td>
              <td data-label="التحكم">
                <router-link class="btn btn-primary text-white mx-1"
                             :tooltip="'تعديل'"
                             flow="up"
                             :to="{ path: isCourseScope ? `${basePath}/edit/${question.id}` : `/${gradeSlug}/question/edit/${question.id}`, query: $route.query }">
                  <i class="pi pi-pencil"></i>
                </router-link>
                <button class="btn btn-danger text-white mx-1"
                        type="button"
                        :tooltip="`حذف`"
                        flow="up"
                        @click="deleteQuestion(question.id)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="questions.length === 0">
              <td colspan="8" class="text-center">لا يوجد بيانات</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Single, page-level image preview dialog (one instance for the whole table,
         driven by selectedImage). Previously a Dialog was rendered per row inside
         the v-for, all bound to the same `visible`, so one click opened them all. -->
    <Dialog v-model:visible="visible" modal header="الصورة" :dismissableMask="true" :style="{ width: '70vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <img v-if="selectedImage" :src="selectedImage" alt="question Image" style="width: 100%; height: auto; object-fit: cover; border-radius: 5px;" />
    </Dialog>
  </div>
</template>

<style scoped>

</style>